import logger from '../../services/logger';

import React from "react";

const SocialShareIcons = ({ shareText, pageUrl }) => {
  const encodedText = encodeURIComponent(shareText || "Je viens de gagner un badge sur DCARE ! 💚");
  const encodedUrl = encodeURIComponent(pageUrl || window.location.href);
  logger.log("url badge ",pageUrl);
  logger.log("text ",shareText);
  logger.log("url encodedUrl ",encodedUrl);
  logger.log("encodedText ",encodedText);

  const icons = [
    {
      name: "Facebook",
      icon: "/icons/Facebook.svg",
      url: `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`
    },
    {
      name: "Instagram",
      icon: "/icons/Instagram.svg",
      url: "#"
    },
    {
      name: "LinkedIn",
      icon: "/icons/Linkedin.svg",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
    },
    {
      name: "WhatsApp",
      icon: "/icons/Whatsapp.svg",
      url: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`
    },
    {
      name: "X",
      icon: "/icons/X.svg",
      url: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`
    }
  ];

  return (
    <div className="d-flex align-items-end flex-wrap mt-3 gap-2">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ fontSize: "0.875rem", fontWeight: 500, marginRight: '4px' }}>
          Partager :
        </span>
      </div>
      {icons.map(({ name, icon, url }) => (
        <a
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Partager sur ${name}`}
        >
          <img
            src={icon}
            alt={name}
            style={{
              width: "43px",
              height: "43px",
              objectFit: "contain",
              verticalAlign: "bottom"
            }}
          />
        </a>
      ))}
    </div>
  );
};

export default SocialShareIcons;
